angular.module('ikeweb.event', []);



//////////////////
// WEBPACK FOOTER
// ./src/client/event/event.module.js
// module id = 439
// module chunks = 0